import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { Amount } from "models/utilTypes/currencyType";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { InvoiceVersionsProps } from "models/propTypes/invoicePropTypes";
import { MoreActionMenuItem } from "models/propTypes/menuPropTypes";
//#endregion
//#region components
import { TableAsync, ViewPanel } from "components/common";
import useInvoiceSendMoreActions from "./actions/useMoreActions";
import { useInvoiceService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const InvoiceVersions: React.FC<InvoiceVersionsProps> = (props) => {
  const invoiceService = useInvoiceService();
  const [versionInfo, setVersionInfo] = React.useState<WintSuperkollAPIModel.InvoiceVersionInfo[]>();

  React.useEffect(() => {
    invoiceService.getVersionInfo(props.invoice.id).then((res) => setVersionInfo(res));
  }, [props.invoice.id]);

  const { downloadAction, emailInvoiceAdvancedAction } = useInvoiceSendMoreActions(props.invoice);

  const getRowActions = (row: WintSuperkollAPIModel.InvoiceVersionInfo): MoreActionMenuItem[] => {
    return [downloadAction(row.version), emailInvoiceAdvancedAction(row.version, row.amount)];
  };

  return versionInfo?.length ? (
    <ViewPanel
      title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Versions)}
      icon={IconDefinitionConstants.WVersions}
    >
      <TableAsync<WintSuperkollAPIModel.InvoiceVersionInfo>
        properties={{
          version: {
            description: TranslationKeys.Common.Version,
            formatter: (row: WintSuperkollAPIModel.InvoiceVersionInfo) =>
              row.version === 0
                ? `${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Invoice2)} ${
                    props.invoice.serialNumber ?? ""
                  }`
                : `${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.Reminder)} ${row.version}`,
          },
          createdDate: {
            description: TranslationKeys.Common.Sent,
            formatter: (row: WintSuperkollAPIModel.InvoiceVersionInfo) =>
              row.createdDate !== undefined ? new Date(row.createdDate) : "",
            noWrap: true,
          },
          dueDate: {
            description: TranslationKeys.Common.DueDate,
            formatter: (row: WintSuperkollAPIModel.InvoiceVersionInfo) =>
              row.dueDate !== undefined ? new Date(row.dueDate) : "",
            noWrap: true,
          },
          amount: {
            description: TranslationKeys.Common.Amount,
            formatter: (row: WintSuperkollAPIModel.InvoiceVersionInfo) =>
              new Amount(props.invoice.currency, row.amount),
            alignment: "right",
          },
        }}
        filter={versionInfo}
        hidePaginationIfSinglePage
        rowHoverActionsHandler={getRowActions}
      ></TableAsync>
    </ViewPanel>
  ) : (
    <></>
  );
};

export default InvoiceVersions;
